import styled from 'styled-components';
import { Dropdown } from 'antd';

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  .ant-form-item {
    margin-bottom: 0;
    margin-left: ${({ theme }) => theme.spacing.space_3};
  }
`;

export const StyledDropdown = styled(Dropdown)`
  margin-top: 4px;
}`;
